import { createContext, useContext } from 'react';
import { NavigationContextType } from './navigation.types';

export const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const useNavigationContext = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('Navigation components must be used within a Navigation provider');
  }
  return context;
};
